{
  "title": "Edit FBO Name",
  "nameLabel": "Name",
  "cancelButton": "Cancel",
  "saveButton": "Save"
}
